import { Dispatch } from '@reduxjs/toolkit';
import {connect} from "react-redux";

import CredInputView, { LocalProps }from "../view/view";
import { requestDataFromAPI } from '../../LicenseTableThingy/thunk/table_tunc';
import { requestCredCreationFromAPI, requestMandantenFromAPI, requestModulesFromAPI, requestToleranceDefaultFromAPI } from '../thunk/request_func';
import { actions } from '../actions/Action';
import { RootState } from '../../../app/store';

interface OwnProps {
    id:string;
    url:string;
}

function mapStateToProps(state:RootState, ownProps:OwnProps){
    // state:rootState includes all global variables as state
    const myprops=
    {
        // I can assign local variables for global vars         
        id:"",
        url:"",
        newlicense:state.LicenseInput.model.license,
        mandant:state.LicenseInput.model.mandant,
        modules:state.LicenseInput.model.modules,
        selected:state.LicenseInput.model.selected,
        toleranceDefault:state.LicenseInput.model.toleranceDefault,
        // this variable is pure local an not recommended
    }
    // Return the whole construct to the container itself
    return myprops;
    // NEVER Add ACtions or Functions here
}



function bindDispatchToActions(dispatch:Dispatch<any>){
    return {
        // Include/Define every funciton that might be called here
        onSubmit:(data:any)=>{
            console.log(data);
            dispatch(requestCredCreationFromAPI(data)  as any);
            console.log("Dispatch should be done");
            setTimeout(() => {
                  console.log("Update License Table now");
                  dispatch(requestDataFromAPI() as any);
              }, 2000);
        },
        requestLoadOfStuff:()=>{
            setTimeout(() => {
            dispatch(requestModulesFromAPI()  as any);
            dispatch(requestMandantenFromAPI()  as any);
            dispatch(requestToleranceDefaultFromAPI((percent) => dispatch(actions.SetToleranceDefault({percent}))) as any);
            }, 400);
        },
        onSelectJob:(value:any, checked:any) => {
            console.log(value, checked);
            dispatch(actions.selectJob({value, checked}));
        },
        onFormChange:(data:any, type:string)=>{
            console.log(data);
            dispatch(actions.SetFormData({data:data, type}));
            console.log("Parameter SET");
        },
    }
}


const mergeProps = (
    mapProps:ReturnType<typeof mapStateToProps>, 
    dispatchProps:ReturnType<typeof bindDispatchToActions>,
    ownProps:OwnProps 
    ) => {
  
  const mergedProps:LocalProps = 
  {
    newlicense:mapProps.newlicense,
    mandant:mapProps.mandant,
    modules:mapProps.modules,
    id:mapProps.id,
    url:mapProps.url,
    selected:mapProps.selected,
    toleranceDefault:mapProps.toleranceDefault,
    

    onSubmit:dispatchProps.onSubmit,
    requestLoadOfStuff: dispatchProps.requestLoadOfStuff,
    onSelectJob: dispatchProps.onSelectJob,
    onFormChange:dispatchProps.onFormChange,
    }
  return mergedProps;
}

const LicenseCreateContainer=connect(mapStateToProps, bindDispatchToActions, mergeProps)(CredInputView);
export default LicenseCreateContainer;